export type EventBusCallback = (topic: string, data: any) => any;

export class EventBus {
    private topics: { [id: string]: EventBusCallback[] } = {};

    public subscribe(topic: string, callback: EventBusCallback) {
        if (!this.topics[topic]) {
            this.topics[topic] = [];
        }

        this.topics[topic].push(callback);
    }

    public publish(topic: string, data: any) {
        if (!this.topics[topic] || this.topics[topic].length < 1) {
            return;
        }
        for (const e of this.topics[topic]) {
            e(topic, data);
        }
    }
}
